import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  TIMEZONES,
  getTimezoneLabel,
  getPreferenceTz,
  nowInPreferenceTz,
} from '../../../utils/timezone';
import { updatePreferences } from '../../../actions/preferences';

const P = styled('p')({
  marginBottom: 0,
  color: 'white',
  fontSize: '14px',
});

function TimezoneSelect({ user, intl, updatePreferences: updatePreferencesAction }) {
  const [time, setTime] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    const update = () => {
      setTime(nowInPreferenceTz());
    };

    const interval = setInterval(update, 1000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  const changeTimezone = timezone => {
    updatePreferencesAction({ preference: { timezone } }, () => {
      window.location.reload(false);
    });
  };

  const timezone = user && user.preference && user.preference.timezone;

  const formattedTime = intl.formatDate(time, {
    hour: 'numeric',
    minute: 'numeric',
    timeZone: getPreferenceTz(),
  });

  return (
    <Box style={{ paddingTop: '20px' }}>
      <Box
        onClick={event => setAnchorEl(event.currentTarget)}
        style={{ cursor: 'pointer' }}
      >
        <P style={{ fontWeight: 600 }}>
          {timezone && getTimezoneLabel(timezone)}
        </P>
        <Box
          style={{ display: 'flex', alignItems: 'center', height: '20px' }}
        >
          <P>
            {intl.formatMessage(
              {
                defaultMessage: 'Time Now: {time}',
              },
              { time: formattedTime },
            )}
          </P>
          <ExpandMoreIcon style={{ color: 'white' }} />
        </Box>
      </Box>
      <Menu
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        {TIMEZONES.map(zone => (
          <MenuItem
            onClick={() => changeTimezone(zone.value)}
            key={zone.value}
            style={{ fontFamily: 'Source Sans Pro' }}
          >
            {zone.label}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
}

TimezoneSelect.propTypes = {
  user: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  updatePreferences: PropTypes.func.isRequired,
};

export default injectIntl(
  connect(null, {
    updatePreferences,
  })(TimezoneSelect),
);
